module.exports = __webpack_public_path__ + "static/3-dab013d01b37529dbf6aa4d6a543a039.jpg";